import axios from 'axios'
import { useEffect, useState } from 'react'
import type { ManufacturerRow } from './ManufacturerList.types'

export function useManufacturerData() {
  const [rows, setRows] = useState<ManufacturerRow[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const load = async () => {
      setLoading(true)
      setError(null)

      try {
        const { data } = await axios.get<{
          count: number
          list: ManufacturerRow[]
        }>('/manufacturer')

        setRows(data.list)
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load manufacturers')
      } finally {
        setLoading(false)
      }
    }

    load()
  }, [])

  return { rows, setRows, loading, error }
}
